/**
 * @deprecated Re-exports from `@gzl10/nexus-sdk`. Import from the SDK directly
 * in new code; this file exists only to keep the old import path working.
 */

export { mimeFromFilename, refineMime, FALLBACK_MIME } from '@gzl10/nexus-sdk'
